import cn from 'classnames';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './PricingProductDescription.module.scss';

import type { PricingProduct } from './PricingBlock.types';

const baseClass = 'pricing-product-desc';

interface Props {
  data: PricingProduct['pricing_groups'];
  theme?: 'light' | 'dark';
  className?: string;
}

export const PricingProductDescription = ({ data, theme = 'light', className }: Props) => {
  return (
    <div className={cn(styles[`${baseClass}-wrapper`], styles[`${baseClass}-${theme}`], className)}>
      <div className={styles[`${baseClass}-list`]}>
        {data.map((item) => (
          <div key={item} className={styles[`${baseClass}-item`]}>
            <Icon type="check-10" />

            <p>{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
